import { Clear } from "@mui/icons-material";
import ButtonCmp, { BTT_SHAPE } from "components/controls/buttons/ButtonCmp";
import { NATSPublish } from "plugins/nats";
import { FunctionComponent, useMemo } from "react";
import farmSo from "stores/farm";
import metaSo from "stores/metadata";



const AlertsFooter: FunctionComponent = () => {

	// STORE

	// HOOKs
	const service = farmSo.state.componentSelect?.subjects?.[0]

	// HANDLERs
	const handleResetAll = () => {
		// const resetMetas = metaSo.state.metadata
		// 	.filter(meta => meta.alias.includes("fAlarm_ACK"))
		// resetMetas.forEach(meta => NATSPublish(meta.serviceCode, meta.alias, 1))
		NATSPublish(service, "AALXXX_fAlarm_ACK", 1)
		NATSPublish(service, "DALXXX_fAlarm_ACK", 1)
	}

	// RENDER
	return <>
		<ButtonCmp sx={{ ml: "26px", mr: "20px" }}
			shape={BTT_SHAPE.MAIN}
			startIcon={<Clear />}
			onClick={handleResetAll}
		>RESET ALL</ButtonCmp>
	</>
}

export default AlertsFooter